import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A promises gotcha that will catch you out",
  "description": "",
  "published": "2019-12-16T00:00:00.000Z",
  "redirect_from": ["/blog/a-promises-gotcha-that-will-catch-you-out/swizec/9261"],
  "categories": "Front End, Technical",
  "hero": "./img/2i7MXrB.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You think you're a JavaScript expert and then you find this all over your codebase.`}</p>
    <p>{`Happened to us on Friday. You shoulda seen the look of defeat on my coworker's face. Looked like he was ready to give up software and become a goat herder in the Andes 😂`}</p>
    <p><img parentName="p" {...{
        "src": "/f172daa2c3cc3eb63f80dd4216b6daae/media-Z2wkLVzjpM784-giphy.gif",
        "alt": "goat_herder giphy"
      }}></img></p>
    <p>{`So what happened?`}</p>
    <p>{`He's performing a networking audit of our codebase. A large app we've built over the years. I built the first version in Backbone, then a team rewrote with Vue, then we all kind of contributed here and there.`}</p>
    <p>{`And there's been issues. Bugs so frequent users gave up reporting them. They just refresh and move on.`}</p>
    <p>{`Well, our networking layer leaks errors like a rusty old bucket you find in the back of the shed. API throws an error, app flinches, shrugs it off, and moves on.`}</p>
    <p>{`Users get undefined behavior galore. App thinks there's data. There isn't data.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/e5166/2i7MXrB.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.81614349775785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M16%2012c0%2010%200%2012%202%2012%202%201%203%200%202-12%200-11%200-12-2-12s-2%201-2%2012m109-6l3%2015c3%2010%206%2015%205%207-2-8-3-13-2-14l1-3c0-3%200-3%202-3V2c0-1-1-2-5-2h-4v6m62-6l3%208%206%2015%206%2013c5%205%205%207%201%209l-3%202c0%202-7%202-10%201-5-3-5-2-2%204%203%205%204%2017%202%2017l-3-2c-1-2-1-2-2%202-2%204-5%206-6%204-2-2-5-1-5%201s3%204%205%204c2-1%203%202%202%207s0%205%204%205c8%200%209-1%208-5l1-13V59l-1-6c4%200%204%204%205%2021l1%2016h10l4-1-2-4-1-11c1-6%201-8-1-9v-5c-2%200-1-2%201-2%203%200%207-3%207-5l-1-2c-3%200-6-8-7-21%200-14-1-16-4-17s-9-8-9-10%205-2%206%200l-1%201c-1%201-1%202%203%205%205%205%206%204%206-4V0h-23m62%202l2%204c0%204%203%205%204%203h1l3%201c3%200%205%203%205%209%200%202-1%202-3%202l-4%201c-1%201-2%201-2-1-1-2-3-1-4%201s0%208%203%2017c2%206%201%2010-1%2011s-2%203%201%203c1-1%202%200%203%201%201%202-1%204-6%204-2%200-3%201-3%203-1%203%200%204%201%201l3-2c2%200%209%204%209%206l2%204%202%202-2%201c-3%202-2%203%203%203%206%200%208-1%207-4s0-9%202-9%2011-14%2011-17c0-2-4-1-9%201-6%203-5%203-4%204%200%201%200%202-3%204l-3%202v-3c0-2%200-3-2-3l-6-1c-3-1-3-1-2-4v-4c-3-4-2-19%201-17l3-1h2v6l-1%203-2%206c-2%203-1%205%202%202l4-3c2-2%202-2%202-13l-1-18V0h-9c-8%200-9%200-9%202M135%2027c-1%208%201%2025%206%2043a195%20195%200%20015%2020l6%201c5%200%207%200%2011-3%207-5%208-6%205-9l-3-2v5a220%20220%200%2001-28-55l-2-4v4m38%201l2%207c1%206%201%206-2%206l-3-5c0-4-2-6-2-3h-2v1l3%207%204%208%203%204v-3l2-6c1-3%201-5-1-11-3-7-4-9-4-5M64%2043c0%207%200%208%202%207%202%200%202%201%200%207-1%204-1%208%201%2014%200%202%200%203-3%204l-3%203-4%203-4%201v6l1%2010%201%203v-4c2-5%2010-7%2011-1l3%203%201%202%201%202h1l4%209%201-2-1-2-2-2a782%20782%200%20000-8v-3l-2-2%2011%201c2%201%202%201%203-1l1-2-9-1c-10%200-11-1-11-6l4-31c0-13%200-14-2-14l-3-2c-2-1-2-1-2%206m-41-3l-1%206c0%204%200%204-1%203-2-2-2-2-2%201s1%204%202%205c2%201%202%202%201%209v8H11C1%2072-1%2072%200%2073l13%202h12l1-4%201-18c0-14%200-15-4-13m301%2029c-10%203-10%203-9%205%202%202%203%202%2010%202%209%200%209%200%209-4l1-3v-4l-11%204m33-1a172%20172%200%20000%2030l2-1c0-1%203-2%207-2l5-1V67h-7l-7%201M217%2090a416%20416%200%2001-56%202c2%201%204%203%204%205s0%202-3%200l-8-1c-6%201-6%200%200-2l4-1h-6l-7-1a1921%201921%200%2001-27%203c0%202%201%203%202%202l8-1-2%202c-2%201-2%201%200%201h3l1%201%202%202v4l2%202c2-1%202%201%200%202l-2%204-1%203h-1a20%2020%200%2001-1%204l-1-2c-2-3-2-3-1%202%201%208%201%2010%203%207v-2l-1-2c0-3%200-3%201-1l2%201c2-1%201%201-2%205l-3%205-1-10-3-7h-1l-1-2v10c-1%203-1%203-4%203s-4%201-2%202v3l1%203%204%203%204%203-2%204v28l2-5c1-2%202-3%204-3%203%200%203%200%202%204%200%206-2%2010-5%2012l-2%204-1%203-2%204c1%202%201%202%207%202l7-1h3l1-2c1-1%202-2%203-1%202%200%202%200%200%201v1l1%203c-1%202-1%203%201%203l1-1h1c1%202%200%203-5%202h-4l8%202%201%201%202%201-8-1c-4%200-6-3-4-4v-1l-1-1-12%201c-3%201-4%201-3%202l-1%203v3c-1%201%203%206%206%206l1%203%202%202c3%200%205%202%205%203l-4%201c-3%200-3%200-1-1%201-1%201-1-2-1-3%201-4%201-3-1l-1-1-1%201-1%201v-1l-1-1-4-1H99l-2-1-3-2v1l-1%201c-3%200-5-1-5-3%200-1-1-2-2-1l-2%202c0%201-1%201-2-1l-3-1c-1%200-1-1%201-3v-4l-2%202-3%202v-2c-2-3%200-17%203-19%202-2%202-3%200-5-3-3-5-40-1-43%201-1%201-1-2-1-2%200-2-1-2-2l-3-2-3-2c0-1-1-2-3-2s-2%200-1%203l3%202%204%202c2%202%202%202%201%206-1%203-2%208-1%2014%200%207%200%209-2%2010l-1%204c0%202-2%203-4%200-1-2-2-10-1-11v-4l-2-7c0-6-2-8-3-4-1%203-2%201-2-4l-1-5-2-5c0-4-1-5-5-7-6-3-8-3-8%201%200%205-1%207-3%205l-2-3h-1l-2%203-1%203-2%204c0%203-3%205-6%202v-4c2-1%203-5%202-5l-5%204c-3%202-3%203-2%204l1%204v4c2%204%202%2010%200%2010-1%201-2%201-1%203%200%201%200%202-2%203l-2%202c0%202-1%204-4%205l-3-1-1-2-3-1c-2%200-2%201-2%208v9h3c4%200%204%206%200%207-3%200-3%200-3%205l1%205c1%201%202%206%200%206s-1%203%201%203l2%204c0%203-1%204-3%203-1-1-1%203-1%2025v27h18c19%200%2019%200%2019-2l1-2v2c0%202%200%202%2010%202h9v-3l-2-9c0-8%200-8%2013-4%208%203%2010%203%2011%202h2l-1%201%205%202a19273%2019273%200%200021%206c3%204%2033%207%2034%204h2c1%202%2024%201%2024-1h1c0%202%207%203%207%201h3a2575%202575%200%2000120-2c-2%200-1-2%201-3l6%201%206%202c2%201%201%201-2%201-5%200-5%202%201%202l4-1c-1-1%200-1%201-1l3%201c1%202%2041%201%2041%200l4-3%204-1-4-2h-5l-1-1-4-1-7-1-7-1-4-1-3-1-4-1c-1-1%203-2%208-2l4-1c1-2%2015-4%2018-3l4-1%205-2%203-1%202-1%201%202%201%201c2-1%202-3%200-3-1-1-1-1%201-1l2%201%202%201c2%200%205-2%205-3l-2-1%203-1c2-1%205-2%206-1l1-1c-1-1%202-3%206-3h3l-2%202h-2l2%201c2%201%202%202%202%207s0%205-3%205l-2%201h2c3%200%203%200%203%209%201%205%201-5%201-21l-1-29c-1-1-7%201-10%202l-8%202a947%20947%200%2000-103%2023%20836%20836%200%2001-26%206c-6%201-14-1-15-4-1-1-1-1-1%201l-1%202-2%201-3-1c-3-2-4-3-2-3%202-1%202-1-1-2s-3-2-1-2v-1h-3l-2%206-1-1h-1l-2-1h-1l-1%201c-2%200-2-2-1-3l-1-1h-10l-3%201-3-1h3l1-2%201-2c3-1%202-3%200-2l-3-1%202-1%202-2%203-1c3%200%203%200%202-2-1-3%200-7%201-7l1%203c1%202%201%203%203%203s2%200%201-1v-1l1-1c0-3%201-2%203%200l2%202a36%2036%200%20016-1v-5c2-3%203-2%203%201%200%202%200%202%201%201l1-1c2%200%203%200%203-2s1-2%202-2l2-1h3c2%201%202%201-1%201-5%201-6%203-3%204%202%200%202%200%201%201s-1%201%201%201%203%200%202%202l-2%201c-4%200-2%204%201%205l3%202%202%202%203%202%205%201%204%201%203%201c3%200%203%200%202-1v-2l1-4c0-2%201-3%202-3v-1l-2-1c0-3-3-2-8%202h-14c-2-1-2-1%200-2l2-2c-1-1%200-1%201-1l2%201%208-2h5c3%200%204%200%203-1-2-1-2-1%200-1s3-2%201-2l-2-1%201-1c2%200%203-6%202-10%200-4%200-5%202-5l19-6c1-1-1-1-8%201l-14%203%201-8%201-8-19-2-6-1-2%206-1%2010v7c-1%202-10%204-21%205h-12l9-1%2014-2%206-2-8%201a477%20477%200%2000-34%201c-2-1%200-3%203-3%202%200%203%200%202-1h-3l-3-1v-2l-2-1-2-1%202-4c1-2%202-3%204-3h1c0-2%203-5%206-6%202%200%202%200%201%201-1%202-1%202%202%203h8l5-1h1v-3c-1-2-2-4-1-5l1-3%203%204c4%204%2011%205%2011%202v-7l-1-4c-1-11-1-11-2-8l-2%205v2c-1%202-4%200-4-3%200-4%205-16%207-18l1-2-3-2-2-2v-3c1-2%202-3%203-2%202%200%202%200%201-1l1-2c3%200%202-3-1-6-2-3-3-3-6-3-4%200-5%200-5-2%200-3%200-3-2-1-2%204-7%201-8-5%200-4%200-4%203-3h3l4%202c2%202%204%202%206%201h5l4-1h3c1%202%204-2%203-5l1-3%203-3c2-4%202-4%207-4h4c2-1-7-3-17-3a310%20310%200%2001-20-2m58%2016l1%202v3c-2%202-2%202%200%202%202%201%202%201%201%203h-6c-1-2-3%200-3%203%200%207-7%208-8%200l-3-4c-2-1-2-1-1%203l-1%204-2-1-1-1-1%203c0%204-1%207-2%207l-1-2c0-4-1-2-1%204v5l7-1c4%200%205%200%205-2%200-4%204-5%209-4%207%201%2010-1%2010-6-1-5%200-8%203-8l2-1%202-6%201-4h-6l-5%201m65%209c0%202-4%205-6%205-1%200-3%201-3%203-2%202-3%203-11%204l-12%202c-8%200-1%201%2011%202%2012%200%2014%200%2015-2%201-1%201-1%202%201l3%202c2%200%202-1%201-6l2-2c3%200%203%200%202-5%200-4-4-7-4-4m54%207l-1%206-1%2019v18l2%201c6%201%206-1%206-19%200-16%200-17-2-17-2-1-3-6-1-7s1-4%200-4l-2-1-1-1v5m-224%205c-2%202-3%2011%200%2012l1%201h-2v6l2%204v2c-2%200-1%203%201%204h4l1-1-1-1-1-1-1-2-1-1%202-1v-4c2-2%203-5%204-14%200-4%200-5-2-5-4-1-4-1-7%201m-68%2010l-5%207v6c-1%202%200%203%201%203%202%201%202%203%200%204l-2-2c-1-3-2-2-2%202%200%203%200%203%201%201v1c0%203%200%205%202%206l2%204%201%201%203-6c-1-1%200-4%201-3l1-7c0-6%200-7%202-9s2-3%202-8c0-4-3-4-7%200m261%207c-2%200-1%204%201%204l1%207v6l1-6c0-7%201-8%206-8%206%200%207%201%207%2010l1%2011c1%202%201%202%201-1%200-10%200-18-2-19v-4c1-1%200-1-1-1l-3%201h-12m-130%206c-3%2014-2%2017%202%2017%202%200%203%200%203-4%202-9%202-12%200-12l-1%201-1%201-1-1v-4l-1-4-1%206m23-3l-7%201h-5l-1%2010c-2%2014-3%2013%209%2011a136%20136%200%200119-3l-4-2c-2-2-2-2%200-2l-1-1-2-2-1-2-2-11c0-1-2-1-5%201m-75%206l-2%202v3l-1%201-1-1h-2c-1%201-2%202-1%203l1%204v3l1-1h1c2%201%204%201%204-1%201-1%200-1-2-1l-3-1%204-1h4l-1%204%201%204%202-2%202-3c3-1%203-2%201-4-2-3-2-3-1-4l2-1c0-1-7-5-9-4M79%20164c-2%2018%206%2035%2017%2035h3l-2-3-6-4c-3-1-10-11-10-13l2-2v-5l-1-8c0-7-2-7-3%200m103%2010l-2%201c-2%200-2%200-1%202v3h-1l-2-2c-2%200-2%205%200%207l1%203%201%202h3c0-1%201-2%203-2%205-2%205-4%203-6l-2-2-1-1-1-3a1225%201225%200%2001-1-2m203%2018l-14%204-3%201-5-1-2%201-2%201h-22c-6-1-9%200-7%205v11c0%202%203%203%203%201l1-1%201%202v1l1-1%201-2v2h1l2-2c0-1%201-2%207-2l9-2%206-1c4-1%206-3%201-3l-4%201h-4l-3-1%204-1%207-2%204-1%209-3a59%2059%200%200015-6c11-5%2010-5-6-1m-207%204c-2%200-3%202-3%203l3%201%203%201c0%201-5%202-8%201h-13c-1%201%208%202%2022%202%208%200%2012%200%2011-1h-3l-8-2%202-1%201-2c0-2-4-3-7-2M72%20210l-1%202c1%201%202%207%201%2010%200%202-1%203-2%202l-2%201-8%202c-10%203-14%205-14%207s0%202%201%201h9l2%201%206%201%208%203h4l3-4c1-1%201-1-1-2-2%200-2%200-1-1s1-1-1-2c-5-2-8-6-4-4%204%200%207-2%205-4s-4-9-3-12c0-2%200-2-2-1m175%2022l-2%201h-4l-1%201c-1%203%200%205%202%203%201-2%202-2%204-1%202%200%202%200%201%201h7a216%20216%200%200112-1l4-2%206-2h-6l-6%201h-7c-7-2-12-3-10-1m136%2015c2%201-1%202-6%201l-28%201%201%201a113%20113%200%200110%202l4%201c4-1%205-2%202-2l-2-1%202-1%202%201%201%201h5l2%201-1%201h9l-3-1-2-1h11l-3-2-2-1c2%200%201-2-1-2s-2%200-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/ca0a1/2i7MXrB.webp 223w", "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/75680/2i7MXrB.webp 445w", "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/8d1ba/2i7MXrB.webp 890w", "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/92f8c/2i7MXrB.webp 1200w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/853b2/2i7MXrB.jpg 223w", "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/0a4fe/2i7MXrB.jpg 445w", "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/7f80b/2i7MXrB.jpg 890w", "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/e5166/2i7MXrB.jpg 1200w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/1d9dc8c0cc0dd5f3bee826a9f3f27fa5/7f80b/2i7MXrB.jpg",
              "alt": "2i7MXrB",
              "title": "2i7MXrB",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><em parentName="p">{`"But how"`}</em>{`, you might ask, `}<em parentName="p">{`"Doesn't modern JavaScript make error handling easy as shit?"`}</em></p>
    <p>{`It does! Except when it doesn't.`}</p>
    <p>{`Look at this code:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20makeRequest()%20%7B%0A%09return%20new%20Promise((resolve%2C%20reject)%20%3D%3E%20%7B%0A%09%09reject(%22Something%20went%20wrong%22)%0A%09%7D)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "462px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2043c-2%201-2%209-2%2070v69l3%201h338l3-1v-69c0-68%200-70-2-71-4-2-338-1-340%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f8d633771382fe7fa85255f771a27fa7/ca0a1/techletter.app-screenshot-1576516610434.webp 223w", "/static/f8d633771382fe7fa85255f771a27fa7/75680/techletter.app-screenshot-1576516610434.webp 445w", "/static/f8d633771382fe7fa85255f771a27fa7/c589b/techletter.app-screenshot-1576516610434.webp 462w"],
                "sizes": "(max-width: 462px) 100vw, 462px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f8d633771382fe7fa85255f771a27fa7/e92b6/techletter.app-screenshot-1576516610434.png 223w", "/static/f8d633771382fe7fa85255f771a27fa7/e66bf/techletter.app-screenshot-1576516610434.png 445w", "/static/f8d633771382fe7fa85255f771a27fa7/e389b/techletter.app-screenshot-1576516610434.png 462w"],
                "sizes": "(max-width: 462px) 100vw, 462px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f8d633771382fe7fa85255f771a27fa7/e389b/techletter.app-screenshot-1576516610434.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A mock `}<inlineCode parentName="p">{`makeRequest`}</inlineCode>{` method that always rejects its promise. An async/await version would throw instead.`}</p>
    <p>{`Like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=async%20function%20makeRequest()%20%7B%0A%09throw%20new%20Error(%22Something%20went%20wrong%22)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "446px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50.224215246636774%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'200\\'%20viewBox=\\'0%200%20400%20200\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044l-1%2057c0%2053%200%2055%202%2056h338c2-1%202-3%202-56l-1-57c-2-2-338-2-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d26ae20c8d4772419514935ab4e197fb/ca0a1/techletter.app-screenshot-1576516608665.webp 223w", "/static/d26ae20c8d4772419514935ab4e197fb/75680/techletter.app-screenshot-1576516608665.webp 445w", "/static/d26ae20c8d4772419514935ab4e197fb/5021b/techletter.app-screenshot-1576516608665.webp 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d26ae20c8d4772419514935ab4e197fb/e92b6/techletter.app-screenshot-1576516608665.png 223w", "/static/d26ae20c8d4772419514935ab4e197fb/e66bf/techletter.app-screenshot-1576516608665.png 445w", "/static/d26ae20c8d4772419514935ab4e197fb/6244b/techletter.app-screenshot-1576516608665.png 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d26ae20c8d4772419514935ab4e197fb/6244b/techletter.app-screenshot-1576516608665.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Same effect. Promises make the mistake I'm talking about more apparent. You'll see why.`}</p>
    <p>{`Okay so you've got this function that sometimes returns an error. You try to be a good citizen, which means handling errors instead of blowing up your app.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20getFirstItem()%20%7B%0A%09return%20makeRequest()%0A%09%09.then(response%20%3D%3E%20%7B%0A%09%09%09return%20response.data%5B0%5D%0A%09%09%7D)%0A%09%09.catch(error%20%3D%3E%20%7B%0A%09%09%09console.error(%22There%20was%20an%20error!%22%2C%20error)%0A%09%09%7D)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "542px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'244\\'%20viewBox=\\'0%200%20400%20244\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037l-1%2086%201%2086c3%202%20347%202%20350%200l1-86-1-86c-2-3-348-3-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/647ef971615d4e7c233bfc59ad2cc9e4/ca0a1/techletter.app-screenshot-1576516610370.webp 223w", "/static/647ef971615d4e7c233bfc59ad2cc9e4/75680/techletter.app-screenshot-1576516610370.webp 445w", "/static/647ef971615d4e7c233bfc59ad2cc9e4/3f954/techletter.app-screenshot-1576516610370.webp 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/647ef971615d4e7c233bfc59ad2cc9e4/e92b6/techletter.app-screenshot-1576516610370.png 223w", "/static/647ef971615d4e7c233bfc59ad2cc9e4/e66bf/techletter.app-screenshot-1576516610370.png 445w", "/static/647ef971615d4e7c233bfc59ad2cc9e4/c0388/techletter.app-screenshot-1576516610370.png 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/647ef971615d4e7c233bfc59ad2cc9e4/c0388/techletter.app-screenshot-1576516610370.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You have a `}<inlineCode parentName="p">{`getFirstItem`}</inlineCode>{` method that calls the API and returns an item from its response. If there's an error, it says there was an error.`}</p>
    <p>{`All good, right? Job well done! You're doing error handling and everything. So good.`}</p>
    <p>{`Now look at this code, what does it print?`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20printFirstItem()%20%7B%0A%09getFirstItem()%0A%09%09.then(item%20%3D%3E%20console.log(item))%0A%09%09.catch(error%20%3D%3E%20console.error(%22There%20was%20no%20item%22))%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "574px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'180\\'%20viewBox=\\'0%200%20400%20180\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2035c-2%203-1%20110%201%20111%202%203%20350%203%20352%200%202-1%203-108%201-111S25%2032%2023%2035\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/411db4a9e3c491fe1d82c41c5757ad67/ca0a1/techletter.app-screenshot-1576516610299.webp 223w", "/static/411db4a9e3c491fe1d82c41c5757ad67/75680/techletter.app-screenshot-1576516610299.webp 445w", "/static/411db4a9e3c491fe1d82c41c5757ad67/4e18f/techletter.app-screenshot-1576516610299.webp 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/411db4a9e3c491fe1d82c41c5757ad67/e92b6/techletter.app-screenshot-1576516610299.png 223w", "/static/411db4a9e3c491fe1d82c41c5757ad67/e66bf/techletter.app-screenshot-1576516610299.png 445w", "/static/411db4a9e3c491fe1d82c41c5757ad67/86389/techletter.app-screenshot-1576516610299.png 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/411db4a9e3c491fe1d82c41c5757ad67/86389/techletter.app-screenshot-1576516610299.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Think about it, I'll send you the answer in 30 minutes 😛`}</p>
    <p>{`PS: if you're not that familiar with promises, here's an old video I made in 2017 – a 2min explanation.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=KVYm0qC4b1Y"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v112h401V112c0-62-1-85-1-51v61l-5-1a3951%203951%200%2001-73-4c-2%200-3%200-3%202s-4%201-5-1c-2-2-4-2-26-3l-30-2h-5l-1%205-3%2014-5%2022c-3%207-6%2016-6%2020-3%2010-5%2014-11%2016l-7%203h-4c-12-3-17-4-18-3-1%202-6%200-7-2l-3-2c-2%200-3%200-2-2%200-2-1-3-3-2l-1-1c0-1%207-2%2014-1%2018%204%2029%201%2031-8l1-4h-12l-9-3c-5-1-5-3%200-3s17-2%2020-4l4-5%205-4c1%200%203-3%203-5h-2l-20%202%2010-5%203-3c3-5%200-10-5-9l-8-2c-3-2-6-2-12-2-7%200-10-1-10-4l5-1c9%200%2010-1%2010-8%200-6-1-7-3-7-3%200-3-1-2-5l2-8c1-5%204-8%208-8%202%201%206%206%208%2013%203%2010%2012%2015%2022%2013%2012-1%2019-9%2022-25l2-6%202-4c0-4-2-4-12-6l-10-3c-2-2-3-3-11-3-4-1-6%200-7%201l-4%201-5%201-2%206-3%205h-6c-4-1-5-1-7-3l-6-5-6-4-3-2-3-1c-1-1-14-2-17%200h-6l-3-3-2-4c-4-5%200-7%2011-5%209%202%2012%200%205-2-10-4-13-11-5-13%203%200%203-1%203-3%200-3%201-5%204-7l3-5%202-2c3%200%206-3%205-4l2-1c3%200%209-6%209-8l3-1c2%201%203%200%203-1l1-1%201%201%201%201c1-1%202%200%203%201h5l2%201c1-1%204%202%203%203l1%201h2c0%202%205%204%208%205%204%200%2011%2013%2014%2025l6%2021c1%200%204-5%205-10%200-3%201-5%202-5%202%200%207-4%207-7l3-2%201-1-2-1c-3%200-4-1-3-2l1-4c0-3%200-4%203-5l3-3c0-1%204-6%204-4s2%201%204-2c1-3%201-3-1-2h-2l2-3c3-4%203-4%203%200v1l2-7c0-4%200-4-3-4l-2%202-3%206c-3%203-4%204-3%201l-1-1-1%203h-1l-1%201v2l-3%201c-2%200-2%200-1-1%200-2-1-3-3-1-1%201-1%201-2-1-2-3-1-3-8-2-5%201-9%201-8-1l-1-1V5l1%202%202%201c2%200%202%200%201-2%200-2%200-2%201-1h2c0-3%204-2%205%200%202%203%204%202%202-1-3-4-2-4-131-4H0v113m250-41v2l-1%201c2%206-6%2011-9%207-1-2-2-2-2-1l1%203-2%203-4%203-4%201h-4v4c2%2014%2023%2019%2033%207%204-4%207-15%205-20l-1-3h-5c-5%200-6%200-6-2s1-2%204-3c6-1%204-3-3-3-2%200-3%200-2%201M146%2095l-3%205%201%202%206%208%2010%2011c3%204%204%204%209%204%205-1%2015-4%2018-7l3-2-5%201c-18%203-28-3-33-18l-3-7-3%203m9%201c2%2014%2012%2021%2025%2020%207-2%209-3%209-6s1-5%206-5c4-1%204-1%204-5%200-5-3-6-11-4-9%202-23%202-27-1l-5-2c-2-1-2-1-1%203m73%2014l8%2015c2%202%203%201%203-2-2-6-2-6%202-7l4-2c2%200-2-2-6-2l-7-2h-4m-40%2016l-2%203-2%201-1%201-2-1c0-2-2-3-4-3v2c2%201%202%201%200%201-3%200-5%202-3%202%202%201%202%201%201%204-2%203-3%204-3%202l-1-2v6c0%205%204%206%208%203%202-2%203-3%207-3%202%201%204%200%205-1%201-2%202-2%202-1h1c1-1%200-7-2-9l-1-4c0-3-2-4-3-1m159%2027c0%207%202%2010%203%205%200-1%201-2%202-1%203%201%206-2%206-5%200-5-2-6-7-6h-4v7m-79%2021c0%207%201%209%202%205l3-2c3%200%206-2%206-5s-3-5-7-5h-4v7m22-2c-4%204-1%209%204%209s7-6%204-9-5-3-8%200m12-1c-1%201%200%2010%202%2010l1-4c0-3%200-4%202-4s3%202%203%206c0%203%202%202%202-2%200-3%201-4%203-4s2%200%202%204c0%203%200%204%202%204s1-6-1-9c-1-2-2-2-4-1h-12m74%201c-2%201-3%204-3%209%201%204%203%205%2016%205h11v-15h-11l-13%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d05599a49da385237410258fa0dc035d/ca0a1/techletter.app-screenshot-1576516629907.webp 223w", "/static/d05599a49da385237410258fa0dc035d/75680/techletter.app-screenshot-1576516629907.webp 445w", "/static/d05599a49da385237410258fa0dc035d/0ba47/techletter.app-screenshot-1576516629907.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d05599a49da385237410258fa0dc035d/e92b6/techletter.app-screenshot-1576516629907.png 223w", "/static/d05599a49da385237410258fa0dc035d/e66bf/techletter.app-screenshot-1576516629907.png 445w", "/static/d05599a49da385237410258fa0dc035d/6af66/techletter.app-screenshot-1576516629907.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d05599a49da385237410258fa0dc035d/6af66/techletter.app-screenshot-1576516629907.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20printFirstItem()%20%7B%0A%09getFirstItem()%0A%09%09.then(item%20%3D%3E%20console.log(item))%0A%09%09.catch(error%20%3D%3E%20console.error(%22There%20was%20no%20item%22))%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "574px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'180\\'%20viewBox=\\'0%200%20400%20180\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2035c-2%203-1%20110%201%20111%202%203%20350%203%20352%200%202-1%203-108%201-111S25%2032%2023%2035\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/411db4a9e3c491fe1d82c41c5757ad67/ca0a1/techletter.app-screenshot-1576516613487.webp 223w", "/static/411db4a9e3c491fe1d82c41c5757ad67/75680/techletter.app-screenshot-1576516613487.webp 445w", "/static/411db4a9e3c491fe1d82c41c5757ad67/4e18f/techletter.app-screenshot-1576516613487.webp 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/411db4a9e3c491fe1d82c41c5757ad67/e92b6/techletter.app-screenshot-1576516613487.png 223w", "/static/411db4a9e3c491fe1d82c41c5757ad67/e66bf/techletter.app-screenshot-1576516613487.png 445w", "/static/411db4a9e3c491fe1d82c41c5757ad67/86389/techletter.app-screenshot-1576516613487.png 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/411db4a9e3c491fe1d82c41c5757ad67/86389/techletter.app-screenshot-1576516613487.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Did you figure it out {{subscriber.first_name}}? My team got it wrong. Even folks with decades of JavaScript experience.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "796px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9a18b78937ce0c51c0c90b72bb85019f/d48f1/BYgtzPO.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "25.112107623318387%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'101\\'%20viewBox=\\'0%200%20400%20101\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M4%2029c-2%202-3%206%200%208%206%206%2013-3%208-8-3-3-5-3-8%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/9a18b78937ce0c51c0c90b72bb85019f/ca0a1/BYgtzPO.webp 223w", "/static/9a18b78937ce0c51c0c90b72bb85019f/75680/BYgtzPO.webp 445w", "/static/9a18b78937ce0c51c0c90b72bb85019f/7fcbc/BYgtzPO.webp 796w"],
              "sizes": "(max-width: 796px) 100vw, 796px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/9a18b78937ce0c51c0c90b72bb85019f/e92b6/BYgtzPO.png 223w", "/static/9a18b78937ce0c51c0c90b72bb85019f/e66bf/BYgtzPO.png 445w", "/static/9a18b78937ce0c51c0c90b72bb85019f/d48f1/BYgtzPO.png 796w"],
              "sizes": "(max-width: 796px) 100vw, 796px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/9a18b78937ce0c51c0c90b72bb85019f/d48f1/BYgtzPO.png",
              "alt": "BYgtzPO",
              "title": "BYgtzPO",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`That's right, it prints `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`.`}</p>
    <p>{`o.O`}</p>
    <p>{`You get an error from `}<inlineCode parentName="p">{`getFirstItem`}</inlineCode>{`. `}<strong parentName="p">{`But then the error is handled!`}</strong>{`. The rest of your code carries on in the `}<inlineCode parentName="p">{`.then`}</inlineCode>{` chain like nothing happened.`}</p>
    <p>{`And that's how you build a leaky bucket without realizing it. Multiply that across months and years and many developers and well ... 😅`}</p>
    <p>{`The fix is to `}<em parentName="p">{`always re-throw errors`}</em>{`. Unless you have a damn good reason why it needs to be eated.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20getFirstItem()%20%7B%0A%09return%20makeRequest()%0A%09%09.then(response%20%3D%3E%20%7B%0A%09%09%09return%20response.data%5B0%5D%0A%09%09%7D)%0A%09%09.catch(error%20%3D%3E%20%7B%0A%09%09%09console.error(%22There%20was%20an%20error!%22%2C%20error)%0A%09%09%09throw%20error%0A%09%09%7D)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "542px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "64.57399103139014%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'258\\'%20viewBox=\\'0%200%20400%20258\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2038c-1%203-1%20183%201%20184%202%202%20348%202%20350%200%202-1%202-181%201-184S25%2035%2024%2038\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bb664776a174f1a7b582ebe80a212856/ca0a1/techletter.app-screenshot-1576516608792.webp 223w", "/static/bb664776a174f1a7b582ebe80a212856/75680/techletter.app-screenshot-1576516608792.webp 445w", "/static/bb664776a174f1a7b582ebe80a212856/3f954/techletter.app-screenshot-1576516608792.webp 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bb664776a174f1a7b582ebe80a212856/e92b6/techletter.app-screenshot-1576516608792.png 223w", "/static/bb664776a174f1a7b582ebe80a212856/e66bf/techletter.app-screenshot-1576516608792.png 445w", "/static/bb664776a174f1a7b582ebe80a212856/c0388/techletter.app-screenshot-1576516608792.png 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bb664776a174f1a7b582ebe80a212856/c0388/techletter.app-screenshot-1576516608792.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`With that tiny modification the code works as expected.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "768px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/123327ba0347cbd4ec21d057a71547d4/e5715/d89bP3j.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "27.802690582959645%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'111\\'%20viewBox=\\'0%200%20400%20111\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2035v6c0%204%201%205%203%205%206%200%209-6%205-10-2-2-7-3-8-1m0%2025v6c0%204%201%205%203%205%206%200%209-6%205-10-2-2-7-3-8-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/123327ba0347cbd4ec21d057a71547d4/ca0a1/d89bP3j.webp 223w", "/static/123327ba0347cbd4ec21d057a71547d4/75680/d89bP3j.webp 445w", "/static/123327ba0347cbd4ec21d057a71547d4/8b983/d89bP3j.webp 768w"],
              "sizes": "(max-width: 768px) 100vw, 768px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/123327ba0347cbd4ec21d057a71547d4/e92b6/d89bP3j.png 223w", "/static/123327ba0347cbd4ec21d057a71547d4/e66bf/d89bP3j.png 445w", "/static/123327ba0347cbd4ec21d057a71547d4/e5715/d89bP3j.png 768w"],
              "sizes": "(max-width: 768px) 100vw, 768px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/123327ba0347cbd4ec21d057a71547d4/e5715/d89bP3j.png",
              "alt": "d89bP3j",
              "title": "d89bP3j",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><img parentName="p" {...{
        "src": "/1b57f383375e2479bf870c2316f4be46/media-GCvktC0KFy9l6-giphy.gif",
        "alt": "thumbs_up giphy"
      }}></img></p>
    <p>{`Yes the same rule applies to async/await code. You're eating errors unless you explicitly re-throw.`}</p>
    <p>{`Now go through your project looking for this mistake and try not to cry. 😛`}</p>
    <p>{`Good luck and happy Monday`}</p>
    <p>{`❤️, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      